
<div class="row">
    @if (showLoader) {
<app-loader></app-loader>
}
    @if (showItemsGrid && gridConfig) {
<div class="col mt-4" >
        <!-- Items on @inavista/components: rows are this.gridItems (LocalRowsGridApi); each editable cell shows its
             column's own editor (the templates below, CellEditorHost), so the editors' rules run as before. -->
        <div class="parts-order-items-grid" [style.height.px]="gridHeight">
            <inavista-grid #partsOrderItemsGrid class="so-popup-grid"
                [config]="gridConfig"
                [actionIcons]="actionIcons"
                (rowClick)="onRowClick($event)"
                (rowEditStart)="onRowEditStart($event)"
                (rowCommit)="onRowCommit($event)"
                (rowRevert)="onRowRevert()"
                (actionIconClick)="onActionIconClick($event)"
                (hyperlinkClick)="onHyperlinkClick($event)"
                (toolbarActionClick)="onToolbarAction($event)"
                (exportRequested)="onExportRequested()" />
        </div>
    </div>
}
</div>

<!-- The open row's editors of hidden columns, out of sight (the old grid drew them in its hidden cells). -->
@if (hiddenEditRow) {
    <div class="d-none" aria-hidden="true">
        @for (field of hiddenEditFields; track field) {
            <app-cell-editor [edit]="edits[field]" [field]="field" [rowData]="hiddenEditRow" [registry]="openEditors" />
        }
    </div>
}

<!-- One template per editable cell, drawn with its column's editor (CellEditorHost, @inavista/components controls). -->
<ng-template #itemCodeEditor let-row>
    <app-cell-editor class="items-cell-editor" [edit]="edits['itemCode']" field="itemCode" [rowData]="itemFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #itemDescriptionEditor let-row>
    <app-cell-editor class="items-cell-editor" [edit]="edits['itemDescription']" field="itemDescription" [rowData]="itemFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #serviceItemGroupEditor let-row>
    <app-cell-editor class="items-cell-editor" [edit]="edits['serviceItemGroup']" field="serviceItemGroup" [rowData]="itemFor(row)" [registry]="openEditors" />
</ng-template>
<ng-template #quantityEditor let-row>
    <app-cell-editor class="items-cell-editor" [edit]="edits['quantity']" field="quantity" [rowData]="itemFor(row)" [registry]="openEditors" />
</ng-template>

@if (showItemAdvancedSearchPopup) {
<app-items-advanced-search

    [technicianId]="technicianId"
    (onClose)="onItemAdvancedSearchPopupClose($event)"
></app-items-advanced-search>
}
